export default __webpack_public_path__ + "static/media/B_05_05_bg.ba27f300.mp4";